export default (axios) => ({
  login(data) {
    return axios.post("/login", data);
  },
  profile(){
    return axios.get("/profile")
  }
});
